import { BodyText } from '@unmind/design-system';
import styled, { keyframes, css } from 'styled-components';

export const TranscriptContainer = styled.div`
  width: 100%;
  max-width: 600px;
  margin: auto;
`;

export const TranscriptText = styled(BodyText).attrs(({ theme }) => ({
  color: theme.colors.text.primary,
  sizes: [theme.typography.fontSizes.fontSize20],
}))`
  display: block;
  text-align: left;
`;

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1;  }
`;

type TranscriptSegmentProps = {
  $delay?: number;
  $animate?: boolean;
};

export const TranscriptSegment = styled(BodyText)<TranscriptSegmentProps>`
  display: inline;
  white-space: normal;
  ${({ $animate, $delay }) =>
    $animate
      ? css`
          opacity: 0;
          animation: ${fadeIn} 400ms ease forwards;
          animation-delay: ${$delay}ms;
          will-change: opacity;
        `
      : css`
          opacity: 1;
        `};

  @media (prefers-reduced-motion: reduce) {
    animation: none;
    opacity: 1;
  }
`;
